import {
  UPDATE_ASSESSMENTS_BUILDER_LIST,
  TOGGLE_ASSESSMENTS_BUILDER_LIST_LOADING,
  ASSESSMENTS_BUILDER_LIST_ERROR,
  UPDATE_ASSESSMENTS_BUILDER_STUDENTS_LIST,
  UPDATE_ASSESSMENTS_BUILDER_FILTERED_STUDENTS,
  UPDATE_ASSESSMENTS_BUILDER_TEMPLATE,
  UPDATE_ASSESSMENTS_BUILDER_CLASS,
  UPDATE_ASSESSMENTS_BUILDER_REVIEWERS,
  USERS_CHECKED_STUDENTS_IDS,
  UPDATE_ASSESSMENT,
  RESET_ASSESSMENT_BUILDER_STATE,
  ASSESSMENTS_BUILDER_UPDATE_LIST_STUDENTS,
  ASSESSMENTS_BUILDER_UPDATE_LIST_STUDENTS_ERROR,
  ASSESSMENTS_BUILDER_TOGGLE_LOADING_STUDENTS,
  ASSESSMENTS_BUILDER_UPDATE_LIST_CLASSES,
  ASSESSMENTS_BUILDER_UPDATE_LIST_CLASSES_ERROR,
  ASSESSMENTS_BUILDER_TOGGLE_LOADING_CLASSES
} from '../actions/dataEntryAssessmentBuilderActions'

const initState = {
  name: 'Data Entry Assessment Builder',
  assessmentsBuilder: {
    name: '',
    notes: '',
    round: '',
    rounds: [], // MF-399 — milestones (label + fechas). Vacío = assessment legacy.
    carryForward: true, // MF-399 — heredar marcado del round previo al agregar uno.
    type: '',
    reviewers: [],
    participantRoles: ['Student'],
    sittingDate: null,
    error: {},
    loading: true,
    list: [],
    filteredStudents: [],
    studentsList: [],
    template: null,
    class: {
      filteredClasses: [],
      selectedClasses: []
    },
    checkedIds: [],
    studentsWithMarking: [],
    // MF-532: total de estudiantes que matchean el filtro (NÚMERO). Antes el BE
    // devolvía el array completo de ids aquí (para el select-all) y se reenviaba
    // en cada request; ahora los ids se piden on-demand (getStudentIdsForAssessment).
    totalStudentsCount: 0,
    studentsListError: null,
    studentsListLoading: false,

    classesList: [],
    classesListCount: 0,
    classesListError: null,
    classesListLoading: false
  }
}

const dataEntryAssessmentBuilderReducer = (state = initState, action) => {
  let newState = { ...state }

  switch (action.type) {
    case UPDATE_ASSESSMENTS_BUILDER_STUDENTS_LIST:
      newState.assessmentsBuilder.studentsList = action.payload.value
      break
    case UPDATE_ASSESSMENTS_BUILDER_LIST:
      newState.assessmentsBuilder.list = action.payload.value
      break
    case TOGGLE_ASSESSMENTS_BUILDER_LIST_LOADING:
      newState.assessmentsBuilder.loading = action.payload.value
      break
    case ASSESSMENTS_BUILDER_LIST_ERROR:
      newState.assessmentsBuilder.error = action.payload.value
      break

    case UPDATE_ASSESSMENTS_BUILDER_FILTERED_STUDENTS:
      newState.assessmentsBuilder.filteredStudents = action.payload.value
      break

    case UPDATE_ASSESSMENTS_BUILDER_TEMPLATE:
      newState.assessmentsBuilder.template = action.payload.value
      newState.assessmentsBuilder.error = {
        ...newState.assessmentsBuilder.error,
        template: null
      }
      break

    case UPDATE_ASSESSMENTS_BUILDER_CLASS: {
      const { filteredClasses, selectedClasses } = action.payload.value

      if (filteredClasses) {
        newState.assessmentsBuilder.class = {
          ...newState.assessmentsBuilder.class,
          filteredClasses
        }
      }

      if (selectedClasses) {
        newState.assessmentsBuilder.class = {
          ...newState.assessmentsBuilder.class,
          selectedClasses
        }

        newState.assessmentsBuilder.error = {
          ...newState.assessmentsBuilder.error,
          class: null
        }
      }
      break
    }

    case UPDATE_ASSESSMENTS_BUILDER_REVIEWERS:
      newState.assessmentsBuilder.reviewers = action.payload.value || []
      break

    case USERS_CHECKED_STUDENTS_IDS:
      newState.assessmentsBuilder.checkedIds = action.ids
      break

    case UPDATE_ASSESSMENT:
      newState.assessmentsBuilder = {
        ...state.assessmentsBuilder,
        ...action.payload
      }
      break

    case RESET_ASSESSMENT_BUILDER_STATE:
      newState.assessmentsBuilder = { ...initState?.assessmentsBuilder }
      break

    case ASSESSMENTS_BUILDER_UPDATE_LIST_STUDENTS:
      newState.assessmentsBuilder.studentsList = action.payload.data
      newState.assessmentsBuilder.totalStudentsCount = action.payload.count
      break
    case ASSESSMENTS_BUILDER_UPDATE_LIST_STUDENTS_ERROR:
      newState.assessmentsBuilder.studentsListError = action.payload.error
      break
    case ASSESSMENTS_BUILDER_TOGGLE_LOADING_STUDENTS:
      newState.assessmentsBuilder.studentsListLoading = action.payload.loading
      break

    case ASSESSMENTS_BUILDER_UPDATE_LIST_CLASSES:
      newState.assessmentsBuilder.classesList = action.payload.data
      newState.assessmentsBuilder.classesListCount = action.payload.count
      break
    case ASSESSMENTS_BUILDER_UPDATE_LIST_CLASSES_ERROR:
      newState.assessmentsBuilder.classesListError = action.payload.error
      break
    case ASSESSMENTS_BUILDER_TOGGLE_LOADING_CLASSES:
      newState.assessmentsBuilder.classesListLoading = action.payload.loading
      break
    default:
      break
  }
  return newState
}

export default dataEntryAssessmentBuilderReducer
